"use strict";import r from"./src/theme-darkest.css.js";import{Theme as e}from"./src/Theme.js";import"./core.js";e.registerThemeFragment("darkest","color",r);
//# sourceMappingURL=theme-darkest.js.map
